import React from "react";
import "./styles.css"; 
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
const schemes = [
  { name: "PMAY-G", image: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/2024/12/20241231348418419.png" },
  { name: "Mahatma Gandhi", image: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/2024/12/202412311332947607.png" },
  { name: "NRHM", image: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/2024/12/202412312094436786.png" },
  { name: "SBM", image: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/2024/12/202412311310717347.png" },
];

const links = [
  "Government of India",
  "Government of Maharashtra",
  "Rural Development Department",
  "Divisional Commissioner Office Amravati",
  "Collector Office Buldhana",
  "Government Resolution",
  "Aaple Sarkar",
  "Online RTI",
];
const services = [
    { name: "e-Office", icon: "💻" },
    { name: "Panchayataj Sevarth", icon: "🆔" },
    { name: "ZPFMS", icon: "🏛️" },
  ];

  const logos = [
    { src: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/bfi_thumb/2019032259-qxpscqfq39ses0mgw45gb1cy0yncp4ousxpu6a3j6w.png", alt: "Make in India" },
    { src: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/bfi_thumb/2019032251-qxpscqfq39ses0mgw45gb1cy0yncp4ousxpu6a3j6w.png", alt: "Incredible India" },
    { src: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/bfi_thumb/2019052222-qxpscix0kli474xe40wfr3999voezjv03whyc2eoko.png", alt: "India Gov" },
    { src: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/bfi_thumb/2019052265-qxpscix0kli474xe40wfr3999voezjv03whyc2eoko.png", alt: "Digital India" },
    { src: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/bfi_thumb/2019032217-qxpscqfq39ses0mgw45gb1cy0yncp4ousxpu6a3j6w.png", alt: "PM India" },
    { src: "https://cdnbbsr.s3waas.gov.in/s3b53477c2821c1bf0da5d40e57b870d35/uploads/bfi_thumb/2019041050-qxpsclqj53lz5ytank4bgkjn21aimn674agerwai20.png", alt: "My Gov" },
  ];


  const settings = {
    dots: false,         // Hide navigation dots
    infinite: true,      // Infinite loop
    speed: 500,         // Transition speed
    slidesToShow: 4,    // Show 4 logos at a time
    slidesToScroll: 1,  // Scroll 1 at a time
    autoplay: true,     // Auto-slide
    autoplaySpeed: 2000, // 2s delay
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

const Schemes = () => {
  return (
    <div className="schemes-div">
    <div className="schemes-container">
    {/* Left Section - Services */}
    <div className="services-section">
      {services.map((service, index) => (
        <div className="service-card" key={index}>
          <span className="service-icon">{service.icon}</span>
          <span>{service.name}</span>
        </div>
      ))}
    </div>

    {/* Middle Section - Important Scheme */}
    <div className="schemes-section">
      <h2>Important Scheme</h2>
      <div className="schemes-grid">
        {schemes.map((scheme, index) => (
          <div className="scheme-card" key={index}>
            <img src={scheme.image} alt={scheme.name} />
            <div className="scheme-title">{scheme.name}</div>
          </div>
        ))}
      </div>
    </div>

    {/* Right Section - Quick Links */}
    <div className="links-section">
      <h2>Quick Links</h2>
      <ul className="links-list">
        {links.map((link, index) => (
          <li key={index} className="link-item">
            ▶ {link}
          </li>
        ))}
      </ul>
    </div>
  </div>
     {/* Logo Section */}
     <div className="footer-logos">
      <Slider {...settings}>
        {logos.map((logo, index) => (
          <div key={index} className="footer-logo-slide">
            <img src={logo.src} alt={logo.alt} className="footer-logo" />
          </div>
        ))}
      </Slider>
    </div>
            {/* Links Section */}
            <div className="footer-links">
        <a href="#">Feedback</a> / <a href="#">Website Policies</a> /
        <a href="#">Contact Us</a> / <a href="#">Help</a> /
        <a href="#">Web Information Manager</a>
      </div>
  </div>
  );
};

export default Schemes;
